import {$getSelection, $isElementNode, $isRangeSelection, ElementNode} from "lexical"
import {$createBadgeNode, $isBadgeNode, BadgeType} from "../badge-plugin"
import {BadgeNode} from "../node/badge-node"
import {lexicalGetAncestor} from "../../../../actions/get-ancestor"
import {clearNodeFormatting} from "../../../../actions/clear-formatting"
import {$isFontColorNode} from "../../font-color/font-color-plugin"

const debug = false
// const debug = "toggleBadge"

export default function toggleBadge(badgeType:BadgeType | null) {
    const selection = $getSelection()

    if (!$isRangeSelection(selection)) {
        return
    }
    const nodes = selection.extract()

    debug && console.log(debug, 'nodes', nodes)

    if (!badgeType) {
        // Remove BadgeNodes
        _.map(nodes, (node) => {
            const parent = node.getParent()

            if (parent && $isBadgeNode(parent)) {
                clearNodeFormatting(parent)
            }
        })
    } else {
        debug && console.log(debug, 'Add or merge BadgeNodes', nodes.length)

        // Remove BadgeNodes and FontColorNodes
        _.map(nodes, (node) => {
            const parent = node.getParent()

            if (parent && ($isBadgeNode(parent) || $isFontColorNode(parent))) {
                clearNodeFormatting(parent)
            }
        })

        // Add or merge BadgeNodes
        if (nodes.length === 1) {
            const firstNode = nodes[0];
            const badgeNode = $isBadgeNode(firstNode)
                ? firstNode
                : lexicalGetAncestor(firstNode, $isBadgeNode)

            debug && console.log(debug, 'badgeNode', badgeNode)

            if (badgeNode !== null) {
                badgeNode.replace($createBadgeNode(badgeType), true)
                return
            }
        }

        let prevParent: ElementNode | BadgeNode | null = null;
        let badgeNode: BadgeNode | null = null

        nodes.forEach((node) => {
            const parent = node.getParent()

            if (
                parent === badgeNode ||
                parent === null ||
                ($isElementNode(node) && !node.isInline())
            ) {
                return;
            }

            if ($isBadgeNode(parent)) {
                badgeNode = parent as BadgeNode
                return
            }

            if (!parent.is(prevParent)) {
                prevParent = parent;
                badgeNode = $createBadgeNode(badgeType);

                if ($isBadgeNode(parent)) {
                    if (node.getPreviousSibling() === null) {
                        parent.insertBefore(badgeNode)
                    } else {
                        parent.insertAfter(badgeNode)
                    }
                } else {
                    node.insertBefore(badgeNode)
                }
            }

            if ($isBadgeNode(node)) {
                if (node.is(badgeNode)) {
                    return
                }

                if (badgeNode !== null) {
                    const children = node.getChildren()

                    for (let i = 0; i < children.length; i++) {
                        badgeNode.append(children[i])
                    }
                }

                node.remove()
                return
            }

            if (badgeNode !== null) {
                badgeNode.append(node)
            }
        })
    }
}